module.exports = __webpack_public_path__ + "media/old_images/image-promo-water-03-7cff6546.jpg";